import { Trans } from '@lingui/react'
import { arrayOf, bool, func, shape, string } from 'prop-types'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

import { TENANT_IT } from 'shared/consts'
import store from 'shared/store'
import { PRODUCT_FILTER_RESET } from 'shared/store/ducks/events'
import Button from 'views/components/atoms/Button'
import IconBin from 'views/components/atoms/Icon/IconBin'
import IconCross from 'views/components/atoms/Icon/IconCross'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'

const ClearRefinements = ({ items, refine, filterId, isMobile }) => {
  const {
    publicRuntimeConfig: {
      publicConfig: { tenant },
    },
  } = useShopAndRuntimeConfig()

  return isMobile ? (
    <Button
      name={`clear-filter-${filterId}`}
      onClick={() => {
        refine(items)
        store.dispatch({ type: PRODUCT_FILTER_RESET })
      }}
      disabled={!items.length}
      className="o-AlgoliaInstantSearch__ClearRefinements__button"
    >
      <Trans id="general.label.clearFilters" />
    </Button>
  ) : (
    <ButtonAsLink
      name={`clear-filter-${filterId}`}
      onClick={() => {
        refine(items)
        store.dispatch({ type: PRODUCT_FILTER_RESET })
      }}
      // needed to align items vertically
      className={items.length === 0 ? 'l-flex u-hidden' : 'l-flex'}
    >
      {tenant === TENANT_IT ? (
        <IconBin size="small" />
      ) : (
        <IconCross size="small" />
      )}
      <Trans id="general.label.clearFilters" />
    </ButtonAsLink>
  )
}

ClearRefinements.propTypes = {
  items: arrayOf(shape({})).isRequired,
  refine: func.isRequired,
  filterId: string.isRequired,
  isMobile: bool,
}

ClearRefinements.defaultProps = {
  isMobile: false,
}

export default connectCurrentRefinements(ClearRefinements)
